// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_resolve.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from enum mono.datagateway.v1.RegistryEntityKind
 */ export var RegistryEntityKind = /*#__PURE__*/ function(RegistryEntityKind) {
    /**
   * @generated from enum value: REGISTRY_ENTITY_KIND_UNSPECIFIED = 0;
   */ RegistryEntityKind[RegistryEntityKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * delivery.contacts
   *
   * @generated from enum value: REGISTRY_ENTITY_KIND_CONTACT = 1;
   */ RegistryEntityKind[RegistryEntityKind["CONTACT"] = 1] = "CONTACT";
    /**
   * delivery.company_profiles
   *
   * @generated from enum value: REGISTRY_ENTITY_KIND_COMPANY = 2;
   */ RegistryEntityKind[RegistryEntityKind["COMPANY"] = 2] = "COMPANY";
    /**
   * delivery.government_organizations (tenant or _system)
   *
   * @generated from enum value: REGISTRY_ENTITY_KIND_GOVERNMENT_ORG = 3;
   */ RegistryEntityKind[RegistryEntityKind["GOVERNMENT_ORG"] = 3] = "GOVERNMENT_ORG";
    /**
   * delivery.contract_vehicles
   *
   * @generated from enum value: REGISTRY_ENTITY_KIND_VEHICLE = 4;
   */ RegistryEntityKind[RegistryEntityKind["VEHICLE"] = 4] = "VEHICLE";
    return RegistryEntityKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(RegistryEntityKind)
proto3.util.setEnumType(RegistryEntityKind, "mono.datagateway.v1.RegistryEntityKind", [
    {
        no: 0,
        name: "REGISTRY_ENTITY_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REGISTRY_ENTITY_KIND_CONTACT"
    },
    {
        no: 2,
        name: "REGISTRY_ENTITY_KIND_COMPANY"
    },
    {
        no: 3,
        name: "REGISTRY_ENTITY_KIND_GOVERNMENT_ORG"
    },
    {
        no: 4,
        name: "REGISTRY_ENTITY_KIND_VEHICLE"
    }
]);
/**
 * @generated from enum mono.datagateway.v1.ResolveMode
 */ export var ResolveMode = /*#__PURE__*/ function(ResolveMode) {
    /**
   * InvalidArgument
   *
   * @generated from enum value: RESOLVE_MODE_UNSPECIFIED = 0;
   */ ResolveMode[ResolveMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * no writes
   *
   * @generated from enum value: RESOLVE_MODE_MATCH_ONLY = 1;
   */ ResolveMode[ResolveMode["MATCH_ONLY"] = 1] = "MATCH_ONLY";
    /**
   * never creates a registry row
   *
   * @generated from enum value: RESOLVE_MODE_MATCH_OR_CANDIDATE = 2;
   */ ResolveMode[ResolveMode["MATCH_OR_CANDIDATE"] = 2] = "MATCH_OR_CANDIDATE";
    /**
   * REG-54 decision table
   *
   * @generated from enum value: RESOLVE_MODE_MATCH_OR_CREATE = 3;
   */ ResolveMode[ResolveMode["MATCH_OR_CREATE"] = 3] = "MATCH_OR_CREATE";
    return ResolveMode;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ResolveMode)
proto3.util.setEnumType(ResolveMode, "mono.datagateway.v1.ResolveMode", [
    {
        no: 0,
        name: "RESOLVE_MODE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "RESOLVE_MODE_MATCH_ONLY"
    },
    {
        no: 2,
        name: "RESOLVE_MODE_MATCH_OR_CANDIDATE"
    },
    {
        no: 3,
        name: "RESOLVE_MODE_MATCH_OR_CREATE"
    }
]);
/**
 * @generated from enum mono.datagateway.v1.ResolutionStatus
 */ export var ResolutionStatus = /*#__PURE__*/ function(ResolutionStatus) {
    /**
   * @generated from enum value: RESOLUTION_STATUS_UNSPECIFIED = 0;
   */ ResolutionStatus[ResolutionStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: RESOLUTION_STATUS_MATCHED = 1;
   */ ResolutionStatus[ResolutionStatus["MATCHED"] = 1] = "MATCHED";
    /**
   * @generated from enum value: RESOLUTION_STATUS_CREATED = 2;
   */ ResolutionStatus[ResolutionStatus["CREATED"] = 2] = "CREATED";
    /**
   * @generated from enum value: RESOLUTION_STATUS_CREATED_POSSIBLE_DUPLICATE = 3;
   */ ResolutionStatus[ResolutionStatus["CREATED_POSSIBLE_DUPLICATE"] = 3] = "CREATED_POSSIBLE_DUPLICATE";
    /**
   * @generated from enum value: RESOLUTION_STATUS_CANDIDATE = 4;
   */ ResolutionStatus[ResolutionStatus["CANDIDATE"] = 4] = "CANDIDATE";
    /**
   * @generated from enum value: RESOLUTION_STATUS_AMBIGUOUS = 5;
   */ ResolutionStatus[ResolutionStatus["AMBIGUOUS"] = 5] = "AMBIGUOUS";
    /**
   * @generated from enum value: RESOLUTION_STATUS_UNRESOLVED = 6;
   */ ResolutionStatus[ResolutionStatus["UNRESOLVED"] = 6] = "UNRESOLVED";
    /**
   * @generated from enum value: RESOLUTION_STATUS_REJECTED = 7;
   */ ResolutionStatus[ResolutionStatus["REJECTED"] = 7] = "REJECTED";
    return ResolutionStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ResolutionStatus)
proto3.util.setEnumType(ResolutionStatus, "mono.datagateway.v1.ResolutionStatus", [
    {
        no: 0,
        name: "RESOLUTION_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "RESOLUTION_STATUS_MATCHED"
    },
    {
        no: 2,
        name: "RESOLUTION_STATUS_CREATED"
    },
    {
        no: 3,
        name: "RESOLUTION_STATUS_CREATED_POSSIBLE_DUPLICATE"
    },
    {
        no: 4,
        name: "RESOLUTION_STATUS_CANDIDATE"
    },
    {
        no: 5,
        name: "RESOLUTION_STATUS_AMBIGUOUS"
    },
    {
        no: 6,
        name: "RESOLUTION_STATUS_UNRESOLVED"
    },
    {
        no: 7,
        name: "RESOLUTION_STATUS_REJECTED"
    }
]);
/**
 * RegistryRef points at a registry (or other) record (50-registries §4.11;
 * registry_records.proto, REG-01, reuses this message).
 *
 * @generated from message mono.datagateway.v1.RegistryRef
 */ export class RegistryRef extends Message {
    static fromBinary(bytes, options) {
        return new RegistryRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryRef, a, b);
    }
    constructor(data){
        super(), /**
   * CONTACT | COMPANY | GOVERNMENT_ORG | VEHICLE | PROGRAM | PURSUIT | PROPOSAL |
   * RFI_RESPONSE | LCAT_ANCHOR | LCAT_ENTRY | REGISTRY_CONTRACT | LANDSCAPE |
   * ARTIFACT | PRICING_SHEET | BLACK_HAT | EXTERNAL
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * only for kind=EXTERNAL (SAM.gov, USAspending)
   *
   * @generated from field: string external_url = 4;
   */ _define_property(this, "externalUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryRef, "runtime", proto3);
_define_property(RegistryRef, "typeName", "mono.datagateway.v1.RegistryRef");
_define_property(RegistryRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "external_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveContextRef
 */ export class ResolveContextRef extends Message {
    static fromBinary(bytes, options) {
        return new ResolveContextRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveContextRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveContextRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveContextRef, a, b);
    }
    constructor(data){
        super(), /**
   * PURSUIT | RFI | PROPOSAL | PROGRAM | EVENT | MEETING | DOCUMENT | CLAIM | WATCHLIST | REGISTRY
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * capture_projects.id | rfi id | proposal project id | programs.id | govcon.events.id |
   * customer_interactions.id | artifacts.id | claim lineage id | watch id | ""
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveContextRef, "runtime", proto3);
_define_property(ResolveContextRef, "typeName", "mono.datagateway.v1.ResolveContextRef");
_define_property(ResolveContextRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolveBinderRef names the row a decided candidate writes its registry id
 * back into (registryresolve.RegisterBinder).
 *
 * @generated from message mono.datagateway.v1.ResolveBinderRef
 */ export class ResolveBinderRef extends Message {
    static fromBinary(bytes, options) {
        return new ResolveBinderRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveBinderRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveBinderRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveBinderRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string row_id = 2;
   */ _define_property(this, "rowId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveBinderRef, "runtime", proto3);
_define_property(ResolveBinderRef, "typeName", "mono.datagateway.v1.ResolveBinderRef");
_define_property(ResolveBinderRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "row_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EntityObservation
 */ export class EntityObservation extends Message {
    static fromBinary(bytes, options) {
        return new EntityObservation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityObservation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityObservation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityObservation, a, b);
    }
    constructor(data){
        super(), /**
   * caller-unique within the request; echoed
   *
   * @generated from field: string client_key = 1;
   */ _define_property(this, "clientKey", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * strong identity
   *
   * CONTACT
   *
   * @generated from field: string email = 3;
   */ _define_property(this, "email", ""), /**
   * COMPANY (12 alnum)
   *
   * @generated from field: string uei = 4;
   */ _define_property(this, "uei", ""), /**
   * COMPANY (5 alnum)
   *
   * @generated from field: string cage = 5;
   */ _define_property(this, "cage", ""), /**
   * GOVERNMENT_ORG (VEHICLE: the awarding agency's code)
   *
   * @generated from field: string org_code = 6;
   */ _define_property(this, "orgCode", ""), /**
   * OFFICE | SUBTIER | TOPTIER | SAM_FH
   *
   * @generated from field: string org_code_type = 7;
   */ _define_property(this, "orgCodeType", ""), /**
   * VEHICLE
   *
   * @generated from field: string contract_number = 8;
   */ _define_property(this, "contractNumber", ""), /**
   * mechanism (default) | order
   *
   * @generated from field: string vehicle_kind = 9;
   */ _define_property(this, "vehicleKind", ""), /**
   * descriptive (candidates / create)
   *
   * @generated from field: string name = 10;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string first_name = 11;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 12;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string title = 13;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string phone = 14;
   */ _define_property(this, "phone", ""), /**
   * evidence only
   *
   * @generated from field: string duns = 15;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string agency = 16;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string sub_agency = 17;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string acronym = 18;
   */ _define_property(this, "acronym", ""), /**
   * CONTACT: employer as written
   *
   * @generated from field: string employer_hint = 19;
   */ _define_property(this, "employerHint", ""), /**
   * GOVERNMENT_ORG parent / COMPANY parent registry id
   *
   * @generated from field: string parent_hint_id = 20;
   */ _define_property(this, "parentHintId", ""), /**
   * GOVERNMENT | EXTERNAL | INTERNAL
   *
   * @generated from field: string contact_type_hint = 21;
   */ _define_property(this, "contactTypeHint", ""), /**
   * provenance
   *
   * "robin" | "baltigo.awardpkg" | "graphsync.usaspending" | "sam.notice" | "user" | "assist"
   *
   * @generated from field: string source = 22;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_record_id = 23;
   */ _define_property(this, "sourceRecordId", ""), /**
   * human label stored on candidates
   *
   * @generated from field: string source_label = 24;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string source_artifact_id = 25;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: repeated int32 pages = 26;
   */ _define_property(this, "pages", []), /**
   * promote-from-cache (grammar in REG-54)
   *
   * @generated from field: string public_key = 27;
   */ _define_property(this, "publicKey", ""), /**
   * @generated from field: mono.datagateway.v1.ResolveBinderRef binder = 28;
   */ _define_property(this, "binder", void 0), /**
   * GOVERNMENT_ORG: awarding agency codes (DAT-03); agency/sub_agency carry the names.
   *
   * @generated from field: string toptier_code = 29;
   */ _define_property(this, "toptierCode", ""), /**
   * @generated from field: string subtier_code = 30;
   */ _define_property(this, "subtierCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityObservation, "runtime", proto3);
_define_property(EntityObservation, "typeName", "mono.datagateway.v1.EntityObservation");
_define_property(EntityObservation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "client_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "org_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "org_code_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "vehicle_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "employer_hint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "parent_hint_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "contact_type_hint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 27,
            name: "public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "binder",
            kind: "message",
            T: ResolveBinderRef
        },
        {
            no: 29,
            name: "toptier_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "subtier_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveEntitiesRequest
 */ export class ResolveEntitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveEntitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveEntitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveEntitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveEntitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * DeliveryGatewayService only
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * 1–200
   *
   * @generated from field: repeated mono.datagateway.v1.EntityObservation observations = 2;
   */ _define_property(this, "observations", []), /**
   * @generated from field: mono.datagateway.v1.ResolveMode mode = 3;
   */ _define_property(this, "mode", 0), /**
   * @generated from field: mono.datagateway.v1.ResolveContextRef context = 4;
   */ _define_property(this, "context", void 0), /**
   * DeliveryGatewayService only; exactly one of 5/6
   *
   * @generated from field: string actor_user_id = 5;
   */ _define_property(this, "actorUserId", ""), /**
   * DeliveryGatewayService only; ^system:[a-z0-9._-]{1,40}$
   *
   * @generated from field: string actor_system = 6;
   */ _define_property(this, "actorSystem", ""), /**
   * MATCH_OR_CREATE + human actor: user chose "Add as new"
   *
   * @generated from field: bool force_create = 7;
   */ _define_property(this, "forceCreate", false), /**
   * @generated from field: repeated string declined_candidate_ids = 8;
   */ _define_property(this, "declinedCandidateIds", []), /**
   * report what would happen; writes nothing
   *
   * @generated from field: bool dry_run = 9;
   */ _define_property(this, "dryRun", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveEntitiesRequest, "runtime", proto3);
_define_property(ResolveEntitiesRequest, "typeName", "mono.datagateway.v1.ResolveEntitiesRequest");
_define_property(ResolveEntitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observations",
            kind: "message",
            T: EntityObservation,
            repeated: true
        },
        {
            no: 3,
            name: "mode",
            kind: "enum",
            T: proto3.getEnumType(ResolveMode)
        },
        {
            no: 4,
            name: "context",
            kind: "message",
            T: ResolveContextRef
        },
        {
            no: 5,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor_system",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "force_create",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "declined_candidate_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EntityCandidate
 */ export class EntityCandidate extends Message {
    static fromBinary(bytes, options) {
        return new EntityCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityCandidate, a, b);
    }
    constructor(data){
        super(), /**
   * survivor
   *
   * @generated from field: string registry_id = 1;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * "DISA" | "UEI 1A2B3C4D5E6F" | "VA › VHA"
   *
   * @generated from field: string context_label = 4;
   */ _define_property(this, "contextLabel", ""), /**
   * "Same name", "Same agency (DISA)"
   *
   * @generated from field: repeated string evidence = 5;
   */ _define_property(this, "evidence", []), /**
   * ordering only; never binds
   *
   * @generated from field: double score = 6;
   */ _define_property(this, "score", 0), /**
   * _system gov org
   *
   * @generated from field: bool read_only_reference = 7;
   */ _define_property(this, "readOnlyReference", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityCandidate, "runtime", proto3);
_define_property(EntityCandidate, "typeName", "mono.datagateway.v1.EntityCandidate");
_define_property(EntityCandidate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "read_only_reference",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Resolution
 */ export class Resolution extends Message {
    static fromBinary(bytes, options) {
        return new Resolution().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Resolution().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Resolution().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Resolution, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string client_key = 1;
   */ _define_property(this, "clientKey", ""), /**
   * @generated from field: mono.datagateway.v1.ResolutionStatus status = 2;
   */ _define_property(this, "status", 0), /**
   * survivor; MATCHED / CREATED*
   *
   * @generated from field: string registry_id = 3;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 4;
   */ _define_property(this, "kind", 0), /**
   * email | uei | cage | uei+cage | org_code:OFFICE | contract_number[+agency] |
   * name_in_context | promoted:<public_key> | created | force_created | confirmed
   *
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * delivery.registry_match_candidates.id when filed
   *
   * @generated from field: string candidate_id = 6;
   */ _define_property(this, "candidateId", ""), /**
   * ≤ 5, best first
   *
   * @generated from field: repeated mono.datagateway.v1.EntityCandidate candidates = 7;
   */ _define_property(this, "candidates", []), /**
   * @generated from field: string display_name = 8;
   */ _define_property(this, "displayName", ""), /**
   * "Is this John Smith (DISA)?" (exact component copy)
   *
   * @generated from field: string question = 9;
   */ _define_property(this, "question", ""), /**
   * REJECTED: MISSING_IDENTITY | BAD_EMAIL | BAD_UEI | BAD_CAGE | UNKNOWN_CODE_TYPE | CONTEXT_NOT_VISIBLE
   *
   * @generated from field: string error_code = 10;
   */ _define_property(this, "errorCode", ""), /**
   * @generated from field: string error_message = 11;
   */ _define_property(this, "errorMessage", ""), /**
   * @generated from field: bool promoted = 12;
   */ _define_property(this, "promoted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Resolution, "runtime", proto3);
_define_property(Resolution, "typeName", "mono.datagateway.v1.Resolution");
_define_property(Resolution, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "client_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ResolutionStatus)
        },
        {
            no: 3,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "candidates",
            kind: "message",
            T: EntityCandidate,
            repeated: true
        },
        {
            no: 8,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "error_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "promoted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveEntitiesResponse
 */ export class ResolveEntitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveEntitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveEntitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveEntitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveEntitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * request order
   *
   * @generated from field: repeated mono.datagateway.v1.Resolution results = 1;
   */ _define_property(this, "results", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveEntitiesResponse, "runtime", proto3);
_define_property(ResolveEntitiesResponse, "typeName", "mono.datagateway.v1.ResolveEntitiesResponse");
_define_property(ResolveEntitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: Resolution,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryMatchCandidate
 */ export class RegistryMatchCandidate extends Message {
    static fromBinary(bytes, options) {
        return new RegistryMatchCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryMatchCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryMatchCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryMatchCandidate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * NAME_MATCH | AMBIGUOUS_STRONG_ID | POSSIBLE_DUPLICATE | NEW_ENTITY | EMPLOYMENT_CHANGE | IDENTIFIER_SUGGESTION
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: mono.datagateway.v1.EntityObservation observation = 5;
   */ _define_property(this, "observation", void 0), /**
   * @generated from field: mono.datagateway.v1.ResolveContextRef context = 6;
   */ _define_property(this, "context", void 0), /**
   * "OMEGA pursuit" (visible contexts only)
   *
   * @generated from field: string context_label = 7;
   */ _define_property(this, "contextLabel", ""), /**
   * @generated from field: repeated mono.datagateway.v1.EntityCandidate candidates = 8;
   */ _define_property(this, "candidates", []), /**
   * POSSIBLE_DUPLICATE
   *
   * @generated from field: mono.datagateway.v1.RegistryRef created = 9;
   */ _define_property(this, "created", void 0), /**
   * @generated from field: string question = 10;
   */ _define_property(this, "question", ""), /**
   * @generated from field: string source_label = 11;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: double confidence = 12;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: int64 revision = 13;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string decided_by_name = 15;
   */ _define_property(this, "decidedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 16;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef decided = 17;
   */ _define_property(this, "decided", void 0), /**
   * REG-61: IDENTIFIER_SUGGESTION options (candidates empty)
   *
   * @generated from field: repeated mono.datagateway.v1.PublicIdentifierOption public_options = 18;
   */ _define_property(this, "publicOptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryMatchCandidate, "runtime", proto3);
_define_property(RegistryMatchCandidate, "typeName", "mono.datagateway.v1.RegistryMatchCandidate");
_define_property(RegistryMatchCandidate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation",
            kind: "message",
            T: EntityObservation
        },
        {
            no: 6,
            name: "context",
            kind: "message",
            T: ResolveContextRef
        },
        {
            no: 7,
            name: "context_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "candidates",
            kind: "message",
            T: EntityCandidate,
            repeated: true
        },
        {
            no: 9,
            name: "created",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 10,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "decided_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "decided",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 18,
            name: "public_options",
            kind: "message",
            T: PublicIdentifierOption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryMatchCandidatesRequest
 */ export class ListRegistryMatchCandidatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryMatchCandidatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryMatchCandidatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryMatchCandidatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryMatchCandidatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional
   *
   * @generated from field: mono.datagateway.v1.ResolveContextRef context = 1;
   */ _define_property(this, "context", void 0), /**
   * optional
   *
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * optional
   *
   * @generated from field: repeated string reasons = 3;
   */ _define_property(this, "reasons", []), /**
   * default PENDING (any state when candidate_ids is set)
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string cursor = 5;
   */ _define_property(this, "cursor", ""), /**
   * ≤ 100, default 25
   *
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0), /**
   * batch read by id (≤ 100); the only batch read
   *
   * @generated from field: repeated string candidate_ids = 7;
   */ _define_property(this, "candidateIds", []), /**
   * DeliveryGatewayService only
   *
   * @generated from field: string tenant_id = 8;
   */ _define_property(this, "tenantId", ""), /**
   * DeliveryGatewayService only: viewer ("" = system caller)
   *
   * @generated from field: string actor_user_id = 9;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryMatchCandidatesRequest, "runtime", proto3);
_define_property(ListRegistryMatchCandidatesRequest, "typeName", "mono.datagateway.v1.ListRegistryMatchCandidatesRequest");
_define_property(ListRegistryMatchCandidatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: ResolveContextRef
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 3,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "candidate_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryMatchCandidatesResponse
 */ export class ListRegistryMatchCandidatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryMatchCandidatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryMatchCandidatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryMatchCandidatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryMatchCandidatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryMatchCandidate candidates = 1;
   */ _define_property(this, "candidates", []), /**
   * @generated from field: string next_cursor = 2;
   */ _define_property(this, "nextCursor", ""), /**
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryMatchCandidatesResponse, "runtime", proto3);
_define_property(ListRegistryMatchCandidatesResponse, "typeName", "mono.datagateway.v1.ListRegistryMatchCandidatesResponse");
_define_property(ListRegistryMatchCandidatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidates",
            kind: "message",
            T: RegistryMatchCandidate,
            repeated: true
        },
        {
            no: 2,
            name: "next_cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRegistryMatchCandidateRequest
 */ export class DecideRegistryMatchCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideRegistryMatchCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRegistryMatchCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRegistryMatchCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRegistryMatchCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string candidate_id = 1;
   */ _define_property(this, "candidateId", ""), /**
   * CONFIRM | CREATE_NEW | MERGE_DUPLICATE | KEEP_SEPARATE | REJECT
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * CONFIRM / MERGE_DUPLICATE
   *
   * @generated from field: string chosen_registry_id = 3;
   */ _define_property(this, "chosenRegistryId", ""), /**
   * REJECT (1–500), optional otherwise
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * 0 = skip the check (internal callers deciding a row they just read)
   *
   * @generated from field: int64 expected_revision = 5;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * DeliveryGatewayService only
   *
   * @generated from field: string tenant_id = 6;
   */ _define_property(this, "tenantId", ""), /**
   * DeliveryGatewayService only (required there; becomes decided_by)
   *
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", ""), /**
   * REG-61: CONFIRM on IDENTIFIER_SUGGESTION picks one of public_options
   *
   * @generated from field: string chosen_public_key = 8;
   */ _define_property(this, "chosenPublicKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRegistryMatchCandidateRequest, "runtime", proto3);
_define_property(DecideRegistryMatchCandidateRequest, "typeName", "mono.datagateway.v1.DecideRegistryMatchCandidateRequest");
_define_property(DecideRegistryMatchCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "chosen_registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "chosen_public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRegistryMatchCandidateResponse
 */ export class DecideRegistryMatchCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideRegistryMatchCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRegistryMatchCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRegistryMatchCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRegistryMatchCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryMatchCandidate candidate = 1;
   */ _define_property(this, "candidate", void 0), /**
   * @generated from field: mono.datagateway.v1.Resolution resolution = 2;
   */ _define_property(this, "resolution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRegistryMatchCandidateResponse, "runtime", proto3);
_define_property(DecideRegistryMatchCandidateResponse, "typeName", "mono.datagateway.v1.DecideRegistryMatchCandidateResponse");
_define_property(DecideRegistryMatchCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidate",
            kind: "message",
            T: RegistryMatchCandidate
        },
        {
            no: 2,
            name: "resolution",
            kind: "message",
            T: Resolution
        }
    ]));
/**
 * ======================= Merge (REG-55, § 4.24) =======================
 *
 * @generated from message mono.datagateway.v1.MergeRegistryEntitiesRequest
 */ export class MergeRegistryEntitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeRegistryEntitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeRegistryEntitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeRegistryEntitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeRegistryEntitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * registry_resolve.proto
   *
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string loser_id = 2;
   */ _define_property(this, "loserId", ""), /**
   * @generated from field: string survivor_id = 3;
   */ _define_property(this, "survivorId", ""), /**
   * 1–500 chars
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * optional: REG-54 POSSIBLE_DUPLICATE row being decided
   *
   * @generated from field: string candidate_id = 5;
   */ _define_property(this, "candidateId", ""), /**
   * internal DeliveryGatewayService variant only
   *
   * @generated from field: string tenant_id = 6;
   */ _define_property(this, "tenantId", ""), /**
   * internal variant only
   *
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeRegistryEntitiesRequest, "runtime", proto3);
_define_property(MergeRegistryEntitiesRequest, "typeName", "mono.datagateway.v1.MergeRegistryEntitiesRequest");
_define_property(MergeRegistryEntitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 2,
            name: "loser_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "survivor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryMergeEvent
 */ export class RegistryMergeEvent extends Message {
    static fromBinary(bytes, options) {
        return new RegistryMergeEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryMergeEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryMergeEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryMergeEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef loser = 3;
   */ _define_property(this, "loser", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef survivor = 4;
   */ _define_property(this, "survivor", void 0), /**
   * @generated from field: string decided_by_name = 5;
   */ _define_property(this, "decidedByName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * ["uei","cage_code"]
   *
   * @generated from field: repeated string moved_identifiers = 8;
   */ _define_property(this, "movedIdentifiers", []), /**
   * @generated from field: google.protobuf.Timestamp reversed_at = 9;
   */ _define_property(this, "reversedAt", void 0), /**
   * @generated from field: string reversed_by_name = 10;
   */ _define_property(this, "reversedByName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryMergeEvent, "runtime", proto3);
_define_property(RegistryMergeEvent, "typeName", "mono.datagateway.v1.RegistryMergeEvent");
_define_property(RegistryMergeEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 3,
            name: "loser",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 4,
            name: "survivor",
            kind: "message",
            T: RegistryRef
        },
        {
            no: 5,
            name: "decided_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "moved_identifiers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "reversed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "reversed_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MergeRegistryEntitiesResponse
 */ export class MergeRegistryEntitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeRegistryEntitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeRegistryEntitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeRegistryEntitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeRegistryEntitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryMergeEvent event = 1;
   */ _define_property(this, "event", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryRef survivor = 2;
   */ _define_property(this, "survivor", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeRegistryEntitiesResponse, "runtime", proto3);
_define_property(MergeRegistryEntitiesResponse, "typeName", "mono.datagateway.v1.MergeRegistryEntitiesResponse");
_define_property(MergeRegistryEntitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: RegistryMergeEvent
        },
        {
            no: 2,
            name: "survivor",
            kind: "message",
            T: RegistryRef
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeRegistryEntitiesRequest
 */ export class UnmergeRegistryEntitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeRegistryEntitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeRegistryEntitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeRegistryEntitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeRegistryEntitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string merge_event_id = 2;
   */ _define_property(this, "mergeEventId", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeRegistryEntitiesRequest, "runtime", proto3);
_define_property(UnmergeRegistryEntitiesRequest, "typeName", "mono.datagateway.v1.UnmergeRegistryEntitiesRequest");
_define_property(UnmergeRegistryEntitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 2,
            name: "merge_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeRegistryEntitiesResponse
 */ export class UnmergeRegistryEntitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeRegistryEntitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeRegistryEntitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeRegistryEntitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeRegistryEntitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryMergeEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeRegistryEntitiesResponse, "runtime", proto3);
_define_property(UnmergeRegistryEntitiesResponse, "typeName", "mono.datagateway.v1.UnmergeRegistryEntitiesResponse");
_define_property(UnmergeRegistryEntitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: RegistryMergeEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryMergeEventsRequest
 */ export class ListRegistryMergeEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryMergeEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryMergeEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryMergeEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryMergeEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryEntityKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string registry_id = 2;
   */ _define_property(this, "registryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryMergeEventsRequest, "runtime", proto3);
_define_property(ListRegistryMergeEventsRequest, "typeName", "mono.datagateway.v1.ListRegistryMergeEventsRequest");
_define_property(ListRegistryMergeEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(RegistryEntityKind)
        },
        {
            no: 2,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryMergeEventsResponse
 */ export class ListRegistryMergeEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryMergeEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryMergeEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryMergeEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryMergeEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * newest first; CONTACT reads contact_merge_events
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryMergeEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryMergeEventsResponse, "runtime", proto3);
_define_property(ListRegistryMergeEventsResponse, "typeName", "mono.datagateway.v1.ListRegistryMergeEventsResponse");
_define_property(ListRegistryMergeEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: RegistryMergeEvent,
            repeated: true
        }
    ]));
/**
 * Internal (DeliveryGatewayService.ResolveRegistrySurvivors, v2.3 reconcile).
 *
 * @generated from message mono.datagateway.v1.ResolveRegistrySurvivorsRequest
 */ export class ResolveRegistrySurvivorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRegistrySurvivorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRegistrySurvivorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRegistrySurvivorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRegistrySurvivorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * ≤ 500; kind + id
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef refs = 2;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRegistrySurvivorsRequest, "runtime", proto3);
_define_property(ResolveRegistrySurvivorsRequest, "typeName", "mono.datagateway.v1.ResolveRegistrySurvivorsRequest");
_define_property(ResolveRegistrySurvivorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "refs",
            kind: "message",
            T: RegistryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveRegistrySurvivorsResponse
 */ export class ResolveRegistrySurvivorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRegistrySurvivorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRegistrySurvivorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRegistrySurvivorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRegistrySurvivorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * request order; same id when not merged; empty id when the row is gone
   *
   * @generated from field: repeated mono.datagateway.v1.RegistryRef survivors = 1;
   */ _define_property(this, "survivors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRegistrySurvivorsResponse, "runtime", proto3);
_define_property(ResolveRegistrySurvivorsResponse, "typeName", "mono.datagateway.v1.ResolveRegistrySurvivorsResponse");
_define_property(ResolveRegistrySurvivorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "survivors",
            kind: "message",
            T: RegistryRef,
            repeated: true
        }
    ]));
/**
 * ======================= Graph projection rebuild (REG-53 / REG-57) =======================
 * Internal (DeliveryGatewayService.RebuildRegistryProjection). The govcon graph is a
 * projection of the registries (D-SOR 6); this is the one rebuild entry point.
 *
 * @generated from message mono.datagateway.v1.RebuildRegistryProjectionRequest
 */ export class RebuildRegistryProjectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RebuildRegistryProjectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RebuildRegistryProjectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RebuildRegistryProjectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RebuildRegistryProjectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * REGISTRY | PUBLIC | ALL ("" = REGISTRY). PUBLIC = nodes and edges from keyed
   * public observations (REG-57); REGISTRY = edges from the registries (REG-53).
   *
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * Report the diff only; nothing is written.
   *
   * @generated from field: bool dry_run = 3;
   */ _define_property(this, "dryRun", false), /**
   * Set = incremental pass (no soft-delete step; the projection is reconciled in
   * place) - DAT-20's post-pass trigger. Unset = full rebuild: every projector edge
   * in scope is soft-deleted and projected again. User overrides and edges of other
   * sources are never deleted.
   *
   * @generated from field: google.protobuf.Timestamp since = 4;
   */ _define_property(this, "since", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RebuildRegistryProjectionRequest, "runtime", proto3);
_define_property(RebuildRegistryProjectionRequest, "typeName", "mono.datagateway.v1.RebuildRegistryProjectionRequest");
_define_property(RebuildRegistryProjectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "since",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RebuildRegistryProjectionResponse
 */ export class RebuildRegistryProjectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RebuildRegistryProjectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RebuildRegistryProjectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RebuildRegistryProjectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RebuildRegistryProjectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 nodes_attached = 1;
   */ _define_property(this, "nodesAttached", 0), /**
   * @generated from field: int32 edges_upserted = 2;
   */ _define_property(this, "edgesUpserted", 0), /**
   * @generated from field: int32 edges_deleted = 3;
   */ _define_property(this, "edgesDeleted", 0), /**
   * @generated from field: int32 unchanged = 4;
   */ _define_property(this, "unchanged", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RebuildRegistryProjectionResponse, "runtime", proto3);
_define_property(RebuildRegistryProjectionResponse, "typeName", "mono.datagateway.v1.RebuildRegistryProjectionResponse");
_define_property(RebuildRegistryProjectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "nodes_attached",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "edges_upserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "edges_deleted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "unchanged",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ======================= Identifier suggestions (REG-61) =======================
 * One suggested public identifier (a UEI from the SAM entity cache or DAT-01
 * award data). Shared here because RegistryMatchCandidate carries them.
 *
 * @generated from message mono.datagateway.v1.PublicIdentifierOption
 */ export class PublicIdentifierOption extends Message {
    static fromBinary(bytes, options) {
        return new PublicIdentifierOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PublicIdentifierOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PublicIdentifierOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PublicIdentifierOption, a, b);
    }
    constructor(data){
        super(), /**
   * "uei:ABC123DEF456" | "piid:36C10B19D0012"
   *
   * @generated from field: string public_key = 1;
   */ _define_property(this, "publicKey", ""), /**
   * legal business name | PIID
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * "UEI ABC123DEF456 · CAGE 1A2B3" | "VA · 2019–2029"
   *
   * @generated from field: string context = 3;
   */ _define_property(this, "context", ""), /**
   * ≤ 3 shown
   *
   * @generated from field: repeated string evidence = 4;
   */ _define_property(this, "evidence", []), /**
   * Legal name, DBA, Address, CAGE, Registration | PIID, Agency, Dates, Obligations
   *
   * @generated from field: repeated mono.datagateway.v1.KeyValueDetail details = 5;
   */ _define_property(this, "details", []), /**
   * @generated from field: double score = 6;
   */ _define_property(this, "score", 0), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 7;
   */ _define_property(this, "retrievedAt", void 0), /**
   * sam_api | sam_extract | usaspending
   *
   * @generated from field: string source = 8;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp as_of = 9;
   */ _define_property(this, "asOf", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PublicIdentifierOption, "runtime", proto3);
_define_property(PublicIdentifierOption, "typeName", "mono.datagateway.v1.PublicIdentifierOption");
_define_property(PublicIdentifierOption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "details",
            kind: "message",
            T: KeyValueDetail,
            repeated: true
        },
        {
            no: 6,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "as_of",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.KeyValueDetail
 */ export class KeyValueDetail extends Message {
    static fromBinary(bytes, options) {
        return new KeyValueDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyValueDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyValueDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KeyValueDetail, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string value = 2;
   */ _define_property(this, "value", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(KeyValueDetail, "runtime", proto3);
_define_property(KeyValueDetail, "typeName", "mono.datagateway.v1.KeyValueDetail");
_define_property(KeyValueDetail, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
